import { Button, Input } from '@you/ui'
import { useState } from 'react'
import { useNavigate, useLocation } from 'react-router-dom'
import { useLogin } from '@/api/hooks/useUser'

interface UsernameLoginFormProps {
  idPrefix?: string
}

export const UsernameLoginForm = ({
  idPrefix = '',
}: UsernameLoginFormProps) => {
  const [username, setUsername] = useState('')
  const [password, setPassword] = useState('')
  const [errors, setErrors] = useState<{
    username?: string
    password?: string
  }>({})

  const navigate = useNavigate()
  const location = useLocation()
  const {
    trigger: login,
    isMutating: isLoggingIn,
    // error: loginError,
  } = useLogin()

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault()
    const newErrors: { username?: string; password?: string } = {}

    if (!username) {
      newErrors.username = '用户名不能为空'
    }
    if (!password) {
      newErrors.password = '密码不能为空'
    }

    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors)
      return
    }

    try {
      await login({
        mobile: username, // 使用username作为mobile字段
        password: password,
      })

      // 获取登录前的页面路径（如果有）
      const from = (location.state as any)?.from?.pathname || '/'
      console.log('登录成功，重定向到:', from)
      navigate(from, { replace: true })
    } catch (e) {
      // The hook's error state will be set, we can display it
      console.error('Login failed', e)
    }
  }

  // 检查表单是否可以提交
  const isFormValid = username.trim() !== '' && password.trim() !== ''

  return (
    <form className="space-y-6" onSubmit={handleSubmit} noValidate>
      <div className="space-y-4">
        <div>
          <label htmlFor={`${idPrefix}username`} className="sr-only">
            用户名
          </label>
          <Input
            id={`${idPrefix}username`}
            name="username"
            type="text"
            autoComplete="username"
            placeholder="请输入用户名"
            value={username}
            onChange={(e) => {
              setUsername(e.target.value)
              if (errors.username) {
                setErrors((prev) => ({ ...prev, username: undefined }))
              }
            }}
            error={!!errors.username}
            errorMessage={errors.username}
          />
        </div>
        <div>
          <label htmlFor={`${idPrefix}password`} className="sr-only">
            密码
          </label>
          <Input
            id={`${idPrefix}password`}
            name="password"
            type="password"
            autoComplete="current-password"
            placeholder="密码"
            value={password}
            onChange={(e) => {
              setPassword(e.target.value)
              if (errors.password) {
                setErrors((prev) => ({ ...prev, password: undefined }))
              }
            }}
            error={!!errors.password}
            errorMessage={errors.password}
          />
        </div>
        {/* {loginError && (
          <p className="text-red-500 text-sm text-center">
            {loginError.message || '登录失败，请重试'}
          </p>
        )} */}
      </div>

      <div className="flex flex-col items-center space-y-6">
        <Button
          className="w-[298px] h-[50px] text-[16px] rounded-[99px] bg-gradient-primary"
          type="submit"
          disabled={isLoggingIn || !isFormValid}
        >
          {isLoggingIn ? '登录中...' : '登录'}
        </Button>
      </div>
    </form>
  )
}
